module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.type !== 'hidden') ? _c('div', {
    class: {
      'input--invalid': _vm.shouldShowValidationError(),
        'input--required': _vm.isRequired(),
        'input--half-width': _vm.halfWidth,
        'input--disabled': _vm.disabled
    }
  }, [_c('input-label-full-width', {
    attrs: {
      "label": _vm.label,
      "required": _vm.required
    }
  }), _vm._v(" "), (_vm.type === 'text') ? [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pendingValue),
      expression: "pendingValue"
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.pendingValue)
    },
    on: {
      "blur": _vm.blur,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pendingValue = $event.target.value
      }, _vm.input],
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.enter($event)
      }
    }
  })] : _vm._e(), _vm._v(" "), (_vm.type === 'email') ? [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pendingValue),
      expression: "pendingValue"
    }],
    attrs: {
      "type": "email",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.pendingValue)
    },
    on: {
      "blur": _vm.blur,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pendingValue = $event.target.value
      }, _vm.input],
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.enter($event)
      }
    }
  })] : _vm._e(), _vm._v(" "), (_vm.type === 'tel') ? [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pendingValue),
      expression: "pendingValue"
    }],
    attrs: {
      "type": "tel",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.pendingValue)
    },
    on: {
      "blur": _vm.blur,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pendingValue = $event.target.value
      }, _vm.input],
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.enter($event)
      }
    }
  })] : _vm._e(), _vm._v(" "), (_vm.type === 'password') ? [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pendingValue),
      expression: "pendingValue"
    }],
    attrs: {
      "type": "password",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.pendingValue)
    },
    on: {
      "blur": _vm.blur,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pendingValue = $event.target.value
      }, _vm.input],
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.enter($event)
      }
    }
  })] : _vm._e(), _vm._v(" "), (_vm.type === 'textarea') ? [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pendingValue),
      expression: "pendingValue"
    }],
    attrs: {
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.pendingValue)
    },
    on: {
      "blur": _vm.blur,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pendingValue = $event.target.value
      }, _vm.input]
    }
  })] : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "input__loading"
  }) : _vm._e(), _vm._v(" "), (_vm.shouldShowValidationError()) ? _c('div', {
    staticClass: "input__validation-error-msg"
  }, [_vm._v("\n    " + _vm._s(_vm.failureMsg) + "\n  ")]) : _vm._e(), _vm._v(" "), (!_vm.shouldShowValidationError() && _vm.additionalInfo && _vm.additionalInfoShow) ? _c('div', {
    staticClass: "input__additional-info"
  }, [_c('small', [_vm._v(_vm._s(_vm.additionalInfo))])]) : _vm._e()], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31d17af4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputWithValidation.vue
// module id = 593
// module chunks = 0